var initializeBlockTimeline = function(block){
    
	
	
    jQuery('.timeline', block).on('init', function(event, slick){
	  var dots =  jQuery( '.timeline li' );
	  
	  dots.each( function( k, v){
		jQuery(this).find( 'button' ).addClass( 'heading'+ k );
	  });
	  var items = slick.$slides;
	  items.each( function( k, v){
		  var text =  jQuery(this).find( 'h2.date' ).text();
		  jQuery( '.heading' + k ).text(text);
	  });
	});
	
	
	jQuery('.timeline:not(.slick-initialized)', block).slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		rows: 1,
		slidesPerRow: 1,
		dots: true,
		arrows: true,
		autoplay: false,
		autoplaySpeed: 3000,
		fade: false,
		easing: "linear",
		pauseOnHover: false,
		infinite: false,
		draggable: false,
		swipe: true,
		adaptiveHeight: false,
		focusOnSelect: true,
		fade: true,
	});
	
    
}

//initialize each block on front end
jQuery(document).ready(function(){
    jQuery('.wp-block-timeline').each(function(){
        initializeBlockTimeline(jQuery(this));
    });
});

//initialize dynamic block preview in the editor
if(window.acf)
    window.acf.addAction('render_block_preview/type=timeline', initializeBlockTimeline);
